import React, { useEffect, useState } from 'react'
import VideoList from '../components/VideoList'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import API_URL from "../config";

const Videos = () => {
   const { id } = useParams(); // video id from URL
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Fetch videos from backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/videos`);
        setVideos(res.data.videos);
      } catch (err) {
        console.error("Failed to fetch videos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (loading) return <p className="text-center mt-20">Loading videos...</p>;
  if (!videos.length) return <p className="text-center mt-20">No videos available</p>;

  // Find current video
  const currentVideo = videos.find(v => v._id === id) || videos[0]; // fallback to first video
  return (
    <div>
      <VideoList videos={videos} />
    </div>
  )
}

export default Videos
